import { render, staticRenderFns } from "./UpdateOfficeForm.vue?vue&type=template&id=67627493&"
import script from "./UpdateOfficeForm.vue?vue&type=script&lang=js&"
export * from "./UpdateOfficeForm.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOfficeForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports